module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.registered),
      expression: "!registered"
    }]
  }, [_vm._v("\n        Sign Up For Free!\n      ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.registered),
      expression: "!registered"
    }],
    staticClass: "subtitle",
    staticStyle: {
      "margin-bottom": "8px"
    }
  }, [_vm._v("\n        Get access to our daily email picks and more!\n      ")]), _vm._v(" "), (_vm.errors.any()) ? _c('div', {
    attrs: {
      "id": "feedback"
    }
  }, [(_vm.errors.has('fname')) ? _c('p', {
    staticClass: "error wrong_name error-box"
  }, [_vm._v("\n          Please enter a first name\n        ")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('lname')) ? _c('p', {
    staticClass: "error wrong_email error-box"
  }, [_vm._v("\n          Please enter a last name\n        ")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('email')) ? _c('p', {
    staticClass: "error wrong_message error-box"
  }, [_vm._v("\n          Please enter an email\n        ")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('password')) ? _c('p', {
    staticClass: "error wrong_message error-box"
  }, [_vm._v("\n          " + _vm._s(_vm.errors.first("password")) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('validateNumber')) ? _c('p', {
    staticClass: "error wrong_message error-box"
  }, [_vm._v("\n          Please enter the spam protection number (5)\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.registered),
      expression: "!registered"
    }],
    attrs: {
      "name": "formregister"
    }
  }, [_c('p', [_vm._v("\n          First Name:\n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.fname),
      expression: "user.fname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "fname",
    attrs: {
      "type": "text",
      "name": "fname",
      "maxlength": "25",
      "data-vv-delay": "3000"
    },
    domProps: {
      "value": _vm._s(_vm.user.fname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.fname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_vm._v("\n          Last Name:\n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.lname),
      expression: "user.lname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "name": "lname",
      "maxlength": "25",
      "data-vv-delay": "2000"
    },
    domProps: {
      "value": _vm._s(_vm.user.lname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.lname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_vm._v("\n          Email:        \n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "type": "text",
      "name": "email",
      "maxlength": "100",
      "data-vv-delay": "2000"
    },
    domProps: {
      "value": _vm._s(_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_vm._v("\n          Password:  \n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:repeatpassword'),
      expression: "'required|confirmed:repeatpassword'"
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "maxlength": "30",
      "data-vv-delay": "2000"
    },
    domProps: {
      "value": _vm._s(_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_vm._v("\n          Repeat PW\n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.confirmPassword),
      expression: "user.confirmPassword"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "id": "label_name",
      "type": "password",
      "name": "repeatpassword",
      "maxlength": "30",
      "data-vv-delay": "2000"
    },
    domProps: {
      "value": _vm._s(_vm.user.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.confirmPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_vm._v("\n          2 + 3 =      \n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.validateNumber),
      expression: "user.validateNumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: /^5$/
      }),
      expression: "{ required: true, regex: /^5$/ }"
    }],
    attrs: {
      "placeholder": "5",
      "type": "number",
      "name": "validateNumber",
      "maxlength": "1",
      "data-vv-delay": "2000"
    },
    domProps: {
      "value": _vm._s(_vm.user.validateNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.validateNumber = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('p', [_c('input', {
    staticClass: "big-btn grey",
    attrs: {
      "type": "submit",
      "value": "Register",
      "name": "submitButton"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.signup($event)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.registered),
      expression: "registered"
    }]
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "24px"
    }
  }, [_c('h3', [_vm._v("Purchase a Premium Membership")]), _vm._v(" "), _vm._l((_vm.ps), function(p) {
    return _c('h5', {
      key: p.id
    }, [_vm._v("\n            " + _vm._s(p.name) + "\n            "), _c('purchase-button', {
      attrs: {
        "package": p
      }
    })], 1)
  })], 2)])]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "success-box"
  }, [_vm._v("\n          Thanks for signing up, you have been registered! Please\n          "), _c('a', {
    attrs: {
      "id": "success-login",
      "href": "#login-box"
    }
  }, [_vm._v("Log In.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "sidebar"
    }
  }, [_c('ul', [_c('li', {
    staticClass: "widget"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h5', [_vm._v("Membership Benefits")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_vm._v("Register for Free to Get Our Daily Email Pick")]), _vm._v(" "), _c('li', [_vm._v("Ability to View Free Picks")]), _vm._v(" "), _c('li', [_vm._v("Access to Powerful Handicapping Information")]), _vm._v(" "), _c('li', [_vm._v("Expert Analysis")]), _vm._v(" "), _c('li', [_vm._v("Quality Picks")]), _vm._v(" "), _c('li', [_vm._v("Excellent Customer Service")]), _vm._v(" "), _c('li', [_vm._v("Information is never disclosed or shared, ever!")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b72dd6c6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Register.vue
// module id = 524
// module chunks = 1